import { render, staticRenderFns } from "./StockLogList.vue?vue&type=template&id=5b1d80b2&scoped=true&lang=pug&"
import script from "./StockLogList.vue?vue&type=script&lang=ts&"
export * from "./StockLogList.vue?vue&type=script&lang=ts&"
import style0 from "./StockLogList.vue?vue&type=style&index=0&id=5b1d80b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d80b2",
  null
  
)

export default component.exports